// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"27e151d4","488":"4ca78e75","540":"52477a0e","568":"6ae72c1b","706":"6c3f0137","803":"fbdeddaf"}[chunkId] + ".chunk.js";
};